module.exports = "<span ng-message=pattern>*Valid tax ID required</span>";